import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef, useState} from 'react'
import ScrollBar from 'react-perfect-scrollbar'
import {Table} from '@components/common/base/table'
import {useSyncEvent} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {useCrmActivities} from './activities-data/use-crm-activities'
import {
  CardBox,
  CrmActivitiesFilters,
  RowData,
  TwMain,
  virtualize
} from './common'
import {EmptyRowsPlaceholder} from './empty-rows-placeholder'
import {DealViewFilter} from './filter/deal-view-filters'
import {
  getInitFiltersValue,
  loadFiltersFromLocalStorage,
  saveFiltersToLocalStorage
} from './filter/save-to-local-storage'
import {getCrmActivitiesColumns} from './get-columns'

export const CrmActivitiesView = observer(() => {
  const [filters, setFilters] = useState<CrmActivitiesFilters>(
    getInitFiltersValue()
  )

  const [modified, setModified] = useState(0)
  const perfectScrollbarRef = useRef<ScrollBar>(null)
  const activitiesView = useCrmActivities({filters, modified})

  useEffect(() => {
    loadFiltersFromLocalStorage(setFilters)
  }, [])

  useSyncEvent(
    'current',
    {debounceTime: 100, filter: activitiesView.depIds ?? []},
    () => {
      setModified(prev => prev + 1)
    },
    [JSON.stringify(activitiesView.depIds)]
  )

  const hasRows = !!activitiesView.tableRows?.length

  return (
    <TwMain>
      <CardBox className="flex h-full w-full">
        <DealViewFilter
          filters={filters}
          setFilters={(filters: CrmActivitiesFilters) => {
            setFilters(filters)
            saveFiltersToLocalStorage(filters)
          }}
          activitiesView={activitiesView}
        />

        <Table<RowData>
          scrollbarRef={perfectScrollbarRef}
          rows={activitiesView.tableRows ?? []}
          className={cn('w-full', hasRows ? 'h-full' : 'h-[32px]')}
          headClassName="h-32 shadow-border-b-1 shadow-line-base !p-0 w-fit"
          headClassNameWrapper="text-subtitle-xs text-secondary w-full"
          tableRowClassName="text-xs-regular"
          tableRowInnerClassName="flex !p-0"
          scrollDirection="xy"
          withHeaderShadow
          shadowType="sm"
          virtualize={virtualize}
          columns={getCrmActivitiesColumns()}
        />

        {!hasRows ? <EmptyRowsPlaceholder /> : null}
      </CardBox>
    </TwMain>
  )
})
